import { render, staticRenderFns } from "./VChart.vue?vue&type=template&id=9c9b032a&scoped=true&"
import script from "./VChart.vue?vue&type=script&lang=ts&"
export * from "./VChart.vue?vue&type=script&lang=ts&"
import style0 from "./VChart.vue?vue&type=style&index=0&id=9c9b032a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9b032a",
  null
  
)

export default component.exports